import React, { useState } from "react";
import { useEffect } from "react";

export const DialogOpener = React.forwardRef(({ children, dialog, initialOpen }, ref) => {
    const [isOpen, setIsOpen] = useState(initialOpen);
    const handleOpen = () => setIsOpen(true)
    const handleClose = () => setIsOpen(false)

    useEffect(() => { setIsOpen(initialOpen) }, [initialOpen])
    return (
        <>
            {children(handleOpen, ref)}
            {dialog(handleClose, {
                open: isOpen,
                onClose: handleClose,
                onCancel: handleClose,
            })}
        </>
    );
});
